import { createContext, useContext, ReactNode } from 'react';
import { useSession } from './SessionContext';
import { useFormUpdates, FormData } from '../hooks/useFormUpdates';

interface FormDataContextType {
  formData: FormData;
  isConnected: boolean;
  error: string | null;
  updateField: (tabName: string, fieldName: string, value: any) => void;
  getFieldValue: (tabName: string, fieldName: string, defaultValue?: any) => any;
  getFieldConfidence: (tabName: string, fieldName: string) => number;
  getFieldSource: (tabName: string, fieldName: string) => string;
  hasLowConfidence: (tabName: string, fieldName: string, threshold?: number) => boolean;
  saveFormData: () => Promise<{ success: boolean; error?: string }>;
  refreshFromDatabase: () => Promise<void>;
  clearFormForTab: (tabName: string) => void;
}

const FormDataContext = createContext<FormDataContextType | undefined>(undefined);

export function FormDataProvider({ children }: { children: ReactNode }) {
  const { effectiveFormSessionId } = useSession();
  // ENABLED: Form updates WebSocket for LLM extraction and YAML population
  const formUpdates = useFormUpdates(effectiveFormSessionId);

  return (
    <FormDataContext.Provider value={formUpdates}>
      {children}
    </FormDataContext.Provider>
  );
}

export function useFormData() {
  const context = useContext(FormDataContext);
  if (context === undefined) {
    throw new Error('useFormData must be used within a FormDataProvider');
  }
  return context;
}
